var map = {
	"./1.png": 135,
	"./10.png": 136,
	"./2.png": 137,
	"./3.png": 138,
	"./4.png": 139,
	"./5.png": 140,
	"./6.png": 141,
	"./7.png": 142,
	"./8.png": 143,
	"./9.png": 144,
	"./bg.png": 96
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 295;